<template>
  <modal ref="confirmModal" class="confirm-modal" :show-header="false">
    <div class="confirmText" slot="body">
      <slot name="body"></slot>
    </div>

    <template slot="footer">
      <div class="actions">
        <button class="btn-cancel" @click="cancelDialog()">Cancelar</button>
        <button class="btn-confirm" @click="confirmDialog()">Confirmar</button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/support/components/modal/Modal.vue';

export default {
  name: 'ConfirmModal',

  props: {
    title: {
      required: false,
      type: String,
      default: 'Deseja prosseguir?',
    },
  },

  data() {
    return {
      accepted: false,
    };
  },

  methods: {
    /**
     * Show confirm dialog and wait the user answer.
     *
     * @returns {Promise<boolean>}
     */
    confirm() {
      this.accepted = false;

      return new Promise((resolve) => {
        this.$refs.confirmModal.openModal();

        const closeListener = () => {
          this.$refs.confirmModal.$off('close', closeListener);

          return resolve(this.accepted);
        };

        this.$refs.confirmModal.$on('close', closeListener);
      });
    },

    /**
     * Cancel the dialog.
     */
    cancelDialog() {
      this.accepted = false;

      this.$refs.confirmModal.closeModal();
    },

    /**
     * Confirm the dialog.
     */
    confirmDialog() {
      this.accepted = true;

      this.$refs.confirmModal.closeModal();
    },
  },

  components: {
    Modal,
  },
};
</script>

<style lang="scss" scoped>
.confirm-modal {
  .confirmText {
    @apply px-4;
    @apply pt-4;
  }

  .actions {
    @apply flex;
    @apply w-full;
    @apply justify-between;
    @apply gap-4;
    @apply px-4;

    .btn-cancel,
    .btn-confirm {
      @apply w-full;
      @apply rounded;
      @apply py-4;
      @apply px-4;
      @apply font-bold;
    }

    .btn-cancel {
      @apply text-secondary-600;
    }

    .btn-cancel:hover {
      @apply text-secondary-800;
    }

    .btn-confirm {
      @apply bg-primary-500;
      @apply text-white;
    }

    .btn-confirm:hover {
      @apply bg-primary-700;
    }
  }
}
</style>
